// Isolated self-service sign-up flow ("/contratar").
// Kept fully separate from the assisted "/nova-conta" flow, which is untouched.
const routes = [
  {
    path: "/contratar",
    name: "contratar",
    meta: {
      title: "Contratar a Mention",
      authRequired: false,
      roles: [],
    },
    component: () => import("@/views/contratar/index.vue"),
  },
];

export default routes;
